// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  border-color: #737373;
}
.card .card-header {
  color: #fff !important;
}
.card .card-body {
  padding: 15px;
}
.card.invalid {
  border-color: #e22922;
}
.card.invalid .card-header {
  background-color: #e22922 !important;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/wrappers/collapse/collapse-wrapper.component.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;AADF;AAGE;EACE,sBAAA;AADJ;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,qBAAA;AAHJ;AAKI;EACE,oCAAA;AAHN","sourcesContent":["@use 'mssvariables' as *;\n\n.card {\n  border-color: theme-color('secondary');\n\n  .card-header {\n    color: theme-color('white') !important;\n  }\n\n  .card-body {\n    padding: 15px;\n  }\n\n  &.invalid {\n    border-color: theme-color('danger');\n\n    .card-header {\n      background-color: theme-color('danger') !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
